<template>
  <div style="text-align:center" v-if="dataList && dataList.length>0">
    <div class="marquee" >
       
        <div class="marquee_box">
        
          <span>最新公告：</span>
            <ul class="marquee_list" :class="{marquee_top:animate}">
                <li @click="go(item.id)" v-for="(item, index) in dataList">
                  {{item.publishTime}}-{{item.title}}
                 
                </li>
            </ul>
            <span @click="closenotice" style="position: absolute; right:26px">X</span>
           
        </div>
    </div>
</div>
 
 
  
</template>

<script>




export default {
  data () {
    return {
      animate: false,
    
    }
  },


  props: {
    dataList: {
      type: Array,
      default: [],
      required: true,
    },
   
  },
  created () {
            setInterval(this.showMarquee, 5000)
        },
     
  methods: {
    showMarquee () {
      
                this.animate = true;
                
                setTimeout(()=>{
                    this.dataList.push(this.dataList[0]);
                this.dataList.shift();
                this.animate = false;
    },1000)},
    closenotice(){
      this.$emit('closenotice',false)

    },
    go (id) {
      this.$router.push({path:'/news/noticedetail/' + id})
    },
   
  },
  computed: {
    optionLeft() {
    return {
        step:0.1,
        direction: 1,// 0向下 1向上 2向左 3向右
        limitMoveNum: 1,
        hoverStop: true,
        openTouch: false,
    };
    },
}


  
}
</script>
<style scoped>
.marquee {

	height: 26px;
	align-items: center;
	color: #3A3A3A;
	background-color: #cfcec6ee;
	display: flex;
	box-sizing: border-box;
  font-size: 12px;
}

.marquee_title {
	padding: 0 20px;
	height: 26px;
	font-size: 14px;
	border-right: 1px solid #fff;
	align-items: center;
}

.marquee_box {
	display: flex;
    line-height: 26px;
	width: auto;
	height: 26px;
  margin: auto;
	overflow: hidden;
}

.marquee_list {
	display: block;
	
}
.marquee_top {
	transition: all 0.5s;
	margin-top: -26px
}

.marquee_list li {
	height: 26px;
	line-height: 26px;
	font-size: 12px;
	padding-left: 20px;
  text-align: left;
  cursor: pointer;
}

.marquee_list li span {
	padding: 0 2px;
}

</style>




// WEBPACK FOOTER //
// src/components/home/Marqueex.vue